import React, { Fragment } from 'react';
import ReactHtmlParser from 'react-html-parser';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import ModalVideo from 'react-modal-video';
import $ from 'jquery';


// ES6 classNameNameNameName-style
class UserInfoContainer extends PreLoginSessionCheck {

    constructor(props) {
        super(props);
        this.state = {
            userInfo: null,
            isOpen: false,
            videoInfo: false
        }
        this.videoId = null;
    }

    componentDidMount() {
        let me = this;
        this.setState({ userInfo: this.props.userData}, 
            () => {        
                me.videoComp();
            }

            );
    }

    backFn = () => {
        if (typeof this.props.closeFn === "function") {
            this.props.closeFn();
        }
    }
    openModal = (someValue) => {
        this.videoId = someValue
        this.setState({isOpen: true})        
        console.log(someValue);
    }
    
    videoComp = (e) => {
        let me = this;
            $('.video-teampage').click(function(){            
            let videoId = $(this).attr('videoid');
            console.log("url", videoId);
            me.openModal(videoId);
        });
       
    }
    render() {
        const videoId = '';
        if (this.state.userInfo)
        {
            let userInfo = this.state.userInfo;
            return (
              
                <div className="userInfocont">
                     <div className="content"><span className="r-btn mr-30 mt-7 backbtn" onClick={this.backFn}>
                        <span><img src="../img/back-arrow.png" alt=""/></span>Back</span>
                     </div>

                    <div className="description numcontent light team-subpage profile-page">                            
                        {ReactHtmlParser(userInfo.content)}   
                        <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.videoId} onClose={() => this.setState({isOpen: false})} /> 
                    </div>

                    <div className="content"><span className="r-btn mr-30 mt-7 backbtn" onClick={this.backFn}>
                        <span><img src="../img/back-arrow.png" alt=""/></span>Back</span>
                    </div>

                </div >
            );
        } else {
            return (
                <Fragment></Fragment>
            )
        }

    }
}

export default UserInfoContainer;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/UserInfoContainer.js